import { InvitationFiltersFormValues } from './types';

export const initialInvitationFormFilters: InvitationFiltersFormValues = {
  createDate: {
    startDate: undefined,
    endDate: undefined,
  },
  fullName: '',
  email: '',
  statuses: null,
};
